import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import Header from 'components/Header/Header';
import RegistrationTwoStepsForm from 'components/Registration/RegistrationTwoStepsForm';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { isLoggedIn, getCurrentUserRole, getCurrentUser } from 'components/UI/Account/ducks/authentication';
import Banner from 'components/Banner/Banner';
import i18n from 'helpers/i18n';
import JobForm from './JobForm';
import config from 'config/api';
import Immutable from 'immutable';
import DynamicForm from 'components/UI/DynamicForm';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Footer from '../Footer';
import BlockButton from 'components/UI/BlockButton';
import WarningIcon from '@material-ui/icons/Warning';
import Template from 'components/Template/Template';
import Dialog from 'components/UI/Dialog/Dialog';

const styles = (theme) => {
  return {
    root: {
      // minHeight: "100%",
      width: '100%',
      height: '100%',
      minHeight: '900px',
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
      '& .MuiTypography-h4': {
        textAlign: 'center'
      },
      '& .MuiTypography-h5': {
        textAlign: 'center'
      },
      '& .MuiTypography-h3': {
        fontSize: '2.2rem',
        lineHeight: '2.8rem',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
          fontSize: '1.6rem',
          lineHeight: '2rem',
          padding: '0 10px',
        },
      },

    },
    header: {
      height: 150,
      [theme.breakpoints.down('sm')]: {
        height: 200,
      },
    },
    content: {
      height: 'calc(100% - 150px - 120px)',
      minHeight: '600px',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    footer: {
      height: 120,
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    paperWrapper: {
      width: '100%',
    },
    paper: {
      padding: theme.spacing(4),
    },
    pageTitle: {
      paddingTop: 16,
      paddingBottom: 16,
      color: theme.palette.primary.main,
      textAlign: 'center',
      fontSize: '2.2rem',
      backgroundColor: '#fff',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(4),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      // boxShadow: theme.shadows[3],
      [theme.breakpoints.down('md')]: {
        fontSize: '1.8rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.5rem',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.3rem',
      },
    },
  };
};

class Registration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      showRecap: false,
      logMessage: false,
    };

    this._onRegistrationCancel = this._onRegistrationCancel.bind(this);
    this._onJobFormComplete = this._onJobFormComplete.bind(this);
    this._onLoginPasswordReset = this._onLoginPasswordReset.bind(this);
    this._onLoginFormComplete = this._onFormComplete.bind(this);
    this._onRegistrationComplete = this._onRegistrationComplete.bind(this);
  }

  _onComplete = () => {
    this.props.history.push('/')

}
  _onJobFormComplete(o) {
    console.log("Registration onJobFormComplete", o);
    this.setState({
      accountJob: o !== undefined && o.value !== undefined ? o.values.accountJob : undefined,
      step: 2,
      isNewMember: true,
    });
  }

  _onRegistrationCancel() {
    this.setState({ accountJob: undefined, step: 1, isNewMember: false });
  }

  _onLoginPasswordReset() {
    this.setState({ accountJob: undefined, step: 3 });
  }

  _onFormComplete() {
    const { onClose, onFormComplete, closeOnComplete } = this.props;
    // console.log('BUBBLED !', onFormComplete)
    const { isNewMember, logMessage } = this.state;
    if (onFormComplete === undefined && onClose !== undefined) onClose();
    else if (onFormComplete !== undefined) {
      onFormComplete({ isNewMember: isNewMember, logMessage: logMessage });
      if (closeOnComplete === true && onClose !== undefined) onClose();
    }
  }

  _onRegistrationComplete(r) {
    this.setState({ showRecap: true });
  }

  render() {
    const { onPanelToggle, classes, userRole, $$event, $$events, isLoggedIn, history } = this.props;
    const { step, accountJob, showRecap, logMessage, isNewMember } = this.state;
    const directRegistration = false;
    const moduleConfig = {
      module: 'account',
      fetchUrl: config.registration + '/edit',
      postUrl: config.registration + '/edit',
      redirectAfterEdit: false,
      afterEdit: 'onFormComplete',
      afterEditLog: '',
      afterEditHideForm: true,
      btCancel: true,
      onFormCancel: this._onRegistrationCancel,
      btCancelLabel: 'Retour',
      btSubmitLabel: 'Envoyer',
      preActionsLegend: i18n.get('registrationPreLegend', { pretty: true }),
    };
    const hiddenFields = ['accountJob'];
    const jobCategories = {
      md: 'isMd',
      sf: 'isSf',
      in: 'isIn',
      lb: 'isLb',
    };
    const jobCategory = accountJob === undefined ? [] : jobCategories[accountJob];

    let ef = {};

    if ($$event !== undefined && $$event.get('id') !== undefined) ef = { fromEvent: $$event.get('id') };
    else if ($$events !== undefined && $$events.get(0) !== undefined)
      ef = { fromEvents: $$events.map((e) => e.get('id')).toArray() };
    ef.accountJob = accountJob;
    const extraFields = Immutable.fromJS(ef);
    
    return (
      <Template>
      <Fade in timeout={1000}>
        <div className={classes.root}>
          
        <Choose>
          <When condition={step === 2}>
            <ScrollToTopOnMount />
            <Dialog open={true} paperClassName={classes.popin}>
              <Box pb={4} px={4}>
                <Box align="center" mb={2} color="primary.black">
                  <If condition={isNewMember === true && i18n.has('registrationSuccessTitle')}>
                    <Typography variant={'h4'} gutterBottom className={classes.popinTitle}>
                      {i18n.get('registrationSuccessTitle', {
                        pretty: true,
                        element: 'div',
                      })}
                    </Typography>
                  </If>
                  <If condition={isNewMember !== true && i18n.has('registrationModifiedTitle')}>
                    <Typography variant={'h4'} gutterBottom className={classes.popinTitle}>
                      {i18n.get('registrationModifiedTitle', {
                        pretty: true,
                        element: 'div',
                      })}
                    </Typography>
                  </If>
                </Box>
                <If
                  condition={
                    isNewMember === true && accountJob === 'x1' && i18n.has('registrationSuccessLogX1')
                  }
                >
                  <Typography variant={'h6'} gutterBottom align="center" className={classes.popinText}>
                    {i18n.get('registrationSuccessLogX1', { pretty: true })}{' '}
                  </Typography>
                </If>
                <If
                  condition={
                    isNewMember === true && accountJob === 'x2' && i18n.has('registrationSuccessLogX2')
                  }
                >
                  <Typography variant={'h6'} gutterBottom align="center" className={classes.popinText}>
                    {i18n.get('registrationSuccessLogX2', { pretty: true })}{' '}
                  </Typography>
                </If>
                <If
                  condition={
                    isNewMember === true && accountJob === 'x3' && i18n.has('registrationSuccessLogX3')
                  }
                >
                  <Typography variant={'h6'} gutterBottom align="center" className={classes.popinText}>
                    {i18n.get('registrationSuccessLogX3', { pretty: true })}{' '}
                  </Typography>
                </If>
                <If
                  condition={
                    isNewMember === true && accountJob === 'x4' && i18n.has('registrationSuccessLogX4')
                  }
                >
                  <Typography variant={'h6'} gutterBottom align="center" className={classes.popinText}>
                    {i18n.get('registrationSuccessLogX4', { pretty: true })}{' '}
                  </Typography>
                </If>
                <If
                  condition={
                    isNewMember === true &&
                    accountJob !== 'x1' &&
                    accountJob !== 'x2' &&
                    accountJob !== 'x3' &&
                    accountJob !== 'x4'
                  }
                >
                  <Typography variant={'h6'} gutterBottom align="center" className={classes.popinText}>
                    {i18n.get('registrationLogSuccess', { pretty: true })}
                  </Typography>
                </If>

                <If condition={isNewMember !== true && i18n.has('subscriptionSelfSuccessText')}>
                  <Typography
                    variant={'h6'}
                    gutterBottom={true}
                    align="center"
                    className={classes.popinText}
                  >
                    {i18n.get('subscriptionSelfSuccessText')}
                  </Typography>
                </If>
                <If condition={directRegistration !== true}>
                  <Box mt={4} align="middle">
                    <Button
                      size="large"
                      className={classes.bigButton}
                      variant="outlined"
                      onClick={this._onComplete}
                    >
                      Terminer
                    </Button>
                  </Box>
                </If>
              </Box>
            </Dialog>
          </When>
          <Otherwise>

            <Typography variant="h2" className={classes.pageTitle}>
              {' '}
              {'Inscription'}
            </Typography>
                  <RegistrationTwoStepsForm
                    onFormComplete={this._onJobFormComplete}
                    step={5}
                  />
                </Otherwise>
              </Choose>
              </div>
      </Fade>
      </Template>
    );
    
  }
}

function mapStateToProps(state) {
  const props = {
    userRole: getCurrentUserRole(state),
    isLoggedIn: isLoggedIn(state),
    $$user: getCurrentUser(state),
  };
  return props;
}

export default withStyles(styles)(withRouter(connect(mapStateToProps)(Registration)));



// WEBPACK FOOTER //
// ./src/components/Registration/Registration.jsx